
import { Toast } from 'vant'
import qs from 'qs'
import wx from "weixin-js-sdk";
import { mapMutations } from 'vuex'
import {isScanUrlSameAsCurrent} from "../utils";
// 注意：微信JS-SDK可以通过npm安装，但建议使用CDN方式加载


export default {
  name: 'ScanConnect',
  data() {
    return {
      isScanning: false,
      isLoading: false,
      isWeChat: false, // 是否在微信浏览器中
      wxReady: false, // 微信JS-SDK是否已配置
      videoStream: null,
      videoElement: null,
      scanInterval: null,
      facingMode: 'environment', // 'user' 前置, 'environment' 后置
      zoomLevel: 1,
      maxZoom: 3,
      scanResult: '',
      showResult: false,
      availableDevices: [],
      currentDeviceId: null,
      canvas: null
    }
  },
  mounted() {
    // 检测是否在微信浏览器中
    this.detectWeChat()
    
    // 作为子组件使用时，只在微信环境中初始化
    if (this.isWeChat) {
      // 检查是否支持摄像头
      this.checkCameraSupport()
      // 在微信中，初始化微信JS-SDK
      this.initWeChatSDK()
    }
  },
  beforeDestroy() {
    this.stopScan()
  },
  methods: {
    ...mapMutations(['setScanResult']),
    /**
     * 检测是否在微信浏览器中
     */
    detectWeChat() {
      const ua = navigator.userAgent.toLowerCase()
      this.isWeChat = /micromessenger/.test(ua)
      return this.isWeChat
    },

    /**
     * 确保微信JS-SDK已加载
     */
    async ensureWxSDKLoaded() {
      return new Promise((resolve, reject) => {
        // 如果已经加载，直接返回
        if (typeof wx !== 'undefined' && wx.config) {
          resolve()
          return
        }

        // 检查是否已经有script标签（可能在HTML中已引用）
        const script = document.querySelector('script[src*="jweixin"]')
        if (script) {
          // 如果script存在但wx未加载，等待加载完成
          let checkCount = 0
          const maxChecks = 100 // 最多检查10秒（100 * 100ms）

          const checkInterval = setInterval(() => {
            checkCount++
            if (typeof wx !== 'undefined' && wx.config) {
              clearInterval(checkInterval)
              resolve()
            } else if (checkCount >= maxChecks) {
              clearInterval(checkInterval)
              reject(new Error('微信JS-SDK加载超时，请检查网络或刷新页面'))
            }
          }, 100)
        } else {
          // 如果HTML中没有引用，则动态加载（备用方案）
          const dynamicScript = document.createElement('script')
          // 使用最新版本的微信JS-SDK（1.6.0），向后兼容
          dynamicScript.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
          dynamicScript.onload = () => {
            // 等待一下确保wx对象完全初始化
            setTimeout(() => {
              if (typeof wx !== 'undefined' && wx.config) {
                resolve()
              } else {
                reject(new Error('微信JS-SDK加载失败'))
              }
            }, 100)
          }
          dynamicScript.onerror = () => {
            reject(new Error('微信JS-SDK脚本加载失败，请检查网络'))
          }
          document.head.appendChild(dynamicScript)
        }
      })
    },

    /**
     * 获取当前页面URL（用于微信签名）
     * 微信签名使用的URL需要去掉hash部分，但保留参数
     */
    getCurrentPageUrl() {
      // 获取当前页面完整URL
      let url = window.location.href.split('#')[0] // 去掉hash部分
      
      // 确保URL格式正确
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        // 如果URL不完整，尝试构建完整URL
        url = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search
      }

      return url
    },

    /**
     * 初始化微信JS-SDK
     */
    async initWeChatSDK() {
      try {
        // 确保微信JS-SDK已加载
        await this.ensureWxSDKLoaded()

        // 获取当前页面URL（去掉hash部分用于签名）
        const url = this.getCurrentPageUrl()

        // 调用接口获取微信配置
        const res = await this.$ajax.post('/etv/getWeChatSignature.json', qs.stringify({
          url: url // 传递当前URL用于签名计算
        }))


        if (res.data.code === 0 && res.data.data) {
          const data = res.data.data

          // 检查必要参数
          if (!data.signature || !data.timestamp || !data.nonceStr) {
            console.error('微信配置参数不完整:', data)
            Toast(this.$t('append_field.wx_config_incomplete'))
            return
          }

          // 检查appId
          if (!data.appId && !data.appid) {
            console.error('微信配置缺少appId:', data)
            Toast(this.$t('append_field.wx_missing_appid'))

            return
          }

          const config = {
            debug: false, // 生产环境建议设为false，避免控制台输出过多信息
            appId: data.appId || data.appid, // 注意：微信JS-SDK使用appId，但后端可能返回appid
            timestamp: parseInt(data.timestamp), // 时间戳，单位秒，确保是数字类型
            nonceStr: data.nonceStr, // 随机字符串
            signature: data.signature, // 签名
            jsApiList: [
              'scanQRCode', // 扫一扫
              'checkJsApi'  // 判断当前客户端版本是否支持指定JS接口
            ] // 必须指定需要使用的JS接口列表
          }


          // 确保wx对象存在
          if (typeof wx === 'undefined') {
            Toast(this.$t('append_field.wx_jssdk_not_loaded'))

            return
          }

          wx.config(config)

          wx.ready(() => {
            this.wxReady = true
            console.log('微信JS-SDK配置成功，可以使用扫码功能')
            
            // 检查JS-SDK是否可用
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: (res) => {

                if (res.checkResult && res.checkResult.scanQRCode === false) {
                  Toast(this.$t('append_field.wx_version_not_support_scan'))
                  this.wxReady = false
                } else {
                  // JS-SDK可用，自动触发微信扫码
                  this.$nextTick(() => {
                    this.startWeChatScan()
                  })
                }
              },
              fail: (err) => {
                console.warn('检查JS-SDK接口失败:', err)
                // 即使检查失败，也尝试触发扫码（某些情况下可能仍可使用）
                this.$nextTick(() => {
                  this.startWeChatScan()
                })
              }
            })
          })

          wx.error((err) => {
            this.wxReady = false
            console.error('微信JS-SDK配置失败:', err)
            
            // 详细错误信息处理
            let errorMsg = '微信扫码功能初始化失败'
            if (err.errMsg) {
              const errMsg = err.errMsg
              console.error('错误详情:', errMsg)
              
              // 根据不同的错误类型提供更详细的提示
              if (errMsg.indexOf('invalid signature') !== -1) {
                errorMsg = this.$t('append_field.wx_signature_failed')
              } else if (errMsg.indexOf('invalid url domain') !== -1) {
                errorMsg = this.$t('append_field.wx_domain_not_config')
              } else if (errMsg.indexOf('config:fail') !== -1) {
                errorMsg = `${this.$t('append_field.wx_config_failed')} ${errMsg}`
              } else {
                errorMsg += `${this.$t('append_field.wx_config_failed')} ${errMsg}`
              }
            }
            Toast(errorMsg)
          })
        } else {
          console.error('获取微信配置失败:', res.data)
          Toast(res.data.msg )
        }
      } catch (error) {
        let errorMsg = this.$t('append_field.wx_scan_init_failed')
        if (error.response) {
          errorMsg += `: ${error.response.status} - ${error.response.statusText}`
        } else if (error.message) {
          errorMsg += `: ${error.message}`
        }
        Toast(errorMsg)
      }
    },

    /**
     * 检查摄像头支持
     */
    async checkCameraSupport() {
      if (this.isWeChat) {
        // 微信浏览器直接返回true，使用微信API
        return true
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Toast(this.$t('append_field.browser_not_support_camera'))
        return false
      }
      return true
    },


    /**
     * 开始扫描二维码
     */
    startScanning() {
      // 动态加载 jsQR 库
      this.loadJSQR().then(() => {
        // 创建 canvas 用于绘制视频帧
        if (!this.canvas) {
          this.canvas = document.createElement('canvas')
        }

        // 根据视频实际尺寸设置canvas大小，提高识别准确率
        const videoWidth = this.videoElement.videoWidth || 640
        const videoHeight = this.videoElement.videoHeight || 480

        // 为了性能，适当缩小canvas尺寸（保持宽高比）
        const scale = Math.min(640 / videoWidth, 480 / videoHeight, 1)
        this.canvas.width = Math.floor(videoWidth * scale)
        this.canvas.height = Math.floor(videoHeight * scale)


        const ctx = this.canvas.getContext('2d')

        // 定时扫描
        this.scanInterval = setInterval(() => {
          if (!this.isScanning || !this.videoElement) {
            return
          }

          // 检查视频是否已准备好
          if (this.videoElement.readyState < 2) {
            return
          }

          try {
            // 绘制当前视频帧到 canvas
            ctx.drawImage(
              this.videoElement,
              0,
              0,
              this.canvas.width,
              this.canvas.height
            )

            // 获取图像数据
            const imageData = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height)

            // 使用 jsQR 识别二维码
            if (window.jsQR) {
              const code = window.jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: 'dontInvert' // 尝试不同的反转策略
              })

              const isSame = isScanUrlSameAsCurrent(code.data)

              if (isSame) {
                // 处理相同URL
                let dataJson = null
                const rawParam = this.extractJsonParam(code.data, 'p')
                if (rawParam) {
                  const decodedData = this.decodeJsonParam(rawParam)
                  const dataObj = JSON.parse(decodedData)
                  if (dataObj && typeof dataObj.data === 'string') {
                    dataObj.data = this.normalizeBase64(dataObj.data)
                  }
                  dataJson = dataObj
                  this.scanResult = dataObj
                  this.setScanResult(dataJson)
                  // 停止扫码
                  this.stopScan()
                  // 通知父组件扫码完成
                  this.$emit('scan-complete')
                } else {
                  this.stopScan()
                  Toast(this.$t('append_field.scan_content_unrecognized'))
                  this.$emit('scan-cancel')
                }
              } else {
                // 处理不同URL
                this.stopScan()
                Toast(this.$t('append_field.scan_content_unrecognized'))
                // 通知父组件扫码取消
                this.$emit('scan-cancel')
              }
            }
          } catch (error) {
            Toast(this.$t('append_field.scan_content_unrecognized'))
            console.error('扫描错误:', error)
          }
        }, 200) // 每200ms扫描一次（降低CPU占用）
      }).catch(error => {
        console.error('加载jsQR库失败:', error)
        Toast(this.$t('append_field.wx_jssdk_not_loaded'))
        this.isLoading = false
      })
    },

    /**
     * 动态加载 jsQR 库
     */
    loadJSQR() {
      return new Promise((resolve, reject) => {
        if (window.jsQR) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.min.js'
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    extractJsonParam(text, key) {
      if (!text || !key) return null
      const markers = [`?${key}=`, `&${key}=`]
      let substring = ''
      for (const marker of markers) {
        const idx = text.indexOf(marker)
        if (idx !== -1) {
          substring = text.slice(idx + marker.length)
          break
        }
      }
      if (!substring) {
        return null
      }
      const braceIndex = substring.indexOf('{')
      if (braceIndex !== -1) {
        substring = substring.slice(braceIndex)
      }
      const extracted = this.extractJsonString(substring)
      return extracted || substring
    },

    extractJsonString(str) {
      if (!str) return null
      let depth = 0
      let inString = false
      let prevChar = ''
      for (let i = 0; i < str.length; i++) {
        const char = str[i]
        if (char === '"' && prevChar !== '\\') {
          inString = !inString
        }
        if (!inString) {
          if (char === '{') {
            depth += 1
          } else if (char === '}') {
            depth -= 1
            if (depth === 0) {
              return str.slice(0, i + 1)
            }
          }
        }
        prevChar = char
      }
      return null
    },

    decodeJsonParam(param) {
      if (!param) return ''
      const sanitized = param.replace(/%(?![0-9A-Fa-f]{2})/g, '%25')
      try {
        return decodeURIComponent(sanitized)
      } catch (e) {
        console.warn('decodeJsonParam failed, fallback to original value', e)
        return param
      }
    },

    normalizeBase64(value) {
      if (typeof value !== 'string') return value
      return value.replace(/\s+/g, '+')
    },


    /**
     * 微信扫码
     */
    startWeChatScan() {
      // 检查wx对象是否存在
      if (typeof wx === 'undefined') {
        Toast(this.$t('append_field.wx_jssdk_not_loaded'))
        return
      }

      if (!this.wxReady) {
        Toast(this.$t('append_field.wx_scan_not_ready'))
        // 如果未就绪，尝试重新初始化
        this.initWeChatSDK().then(() => {
          // 初始化完成后再次尝试扫码
          if (this.wxReady) {
            this.callWeChatScan()
          } else {
            Toast(this.$t('append_field.scan_lib_load_failed'))
          }
        })
        return
      }

      this.callWeChatScan()
    },

    /**
     * 调用微信扫码API
     */
    callWeChatScan() {
      // 再次检查wx对象和wxReady状态
      if (typeof wx === 'undefined') {
        Toast(this.$t('append_field.wx_jssdk_not_loaded'))
        this.isLoading = false
        return
      }

      if (!this.wxReady) {
        Toast(this.$t('append_field.scan_lib_load_failed'))

        this.isLoading = false
        return
      }

      this.isLoading = true

      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是条形码，默认二者都有
        success: (res) => {
          this.isLoading = false
          console.log('微信扫码成功:', res.resultStr)
          // 扫码成功
          const result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          const isSame = isScanUrlSameAsCurrent(result)

          if (isSame) {
            // 处理相同URL
            let dataJson = null
            try {
              const rawParam = this.extractJsonParam(result, 'p')
              if (!rawParam) {
                throw new Error('未找到扫码参数 p')
              }
              const decodedData = this.decodeJsonParam(rawParam)
              const dataObj = JSON.parse(decodedData)
              if (dataObj && typeof dataObj.data === 'string') {
                dataObj.data = this.normalizeBase64(dataObj.data)
              }
              dataJson = dataObj
              this.scanResult = dataObj
              this.setScanResult(dataJson)
              // 通知父组件扫码完成
              this.$emit('scan-complete')
            } catch (error) {
              console.error('解析扫码结果失败:', error)
              Toast(this.$t('append_field.scan_content_unrecognized'))
              this.$emit('scan-cancel')
            }
          } else {
            // 处理不同URL
            Toast(this.$t('append_field.scan_content_unrecognized'))
            // 通知父组件扫码取消
            this.$emit('scan-cancel')
          }

        },
        fail: (err) => {
          this.isLoading = false
          
          if (err.errMsg) {
            const errMsg = err.errMsg
            if (errMsg.indexOf('cancel') !== -1 || errMsg.indexOf('用户取消') !== -1) {
              // 用户取消扫码，通知父组件
              this.$emit('scan-cancel')
            } else if (errMsg.indexOf('config') !== -1 || errMsg.indexOf('permission denied') !== -1) {
              // 配置失败或权限被拒绝
              Toast(this.$t('append_field.wx_scan_permission_denied'))

              this.wxReady = false
              // 通知父组件扫码取消
              setTimeout(() => {
                this.$emit('scan-cancel')
              }, 1500)
            } else if (errMsg.indexOf('function not exist') !== -1) {
              Toast(this.$t('append_field.wx_version_not_support_scan'))

              // 通知父组件扫码取消
              setTimeout(() => {
                this.$emit('scan-cancel')
              }, 1500)
            } else {
              Toast(this.$t('append_field.scan_content_unrecognized'))
              // 通知父组件扫码取消
              setTimeout(() => {
                this.$emit('scan-cancel')
              }, 1500)
            }
          } else {
            Toast(this.$t('append_field.scan_content_unrecognized'))
            // 通知父组件扫码取消
            setTimeout(() => {
              this.$emit('scan-cancel')
            }, 1500)
          }
        },
        cancel: () => {
          this.isLoading = false

          // 用户取消扫码，通知父组件
          this.$emit('scan-cancel')
        }
      })
    },

    /**
     * 停止扫码
     */
    stopScan() {
      this.isScanning = false

      // 清除扫描定时器
      if (this.scanInterval) {
        clearInterval(this.scanInterval)
        this.scanInterval = null
      }

      // 停止视频流
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop())
        this.videoStream = null
      }

      // 清空视频元素
      if (this.videoElement) {
        this.videoElement.srcObject = null
        this.videoElement = null
      }
    },


  }
}
